module.exports = __webpack_public_path__ + "img/teams.c7cc2d91.svg";